<div class="description" *ngIf="table.description" style="display: flex; align-items: center; gap: 0.5rem;">
    <p [innerHTML]="table.description"></p>
    <a id="show-more-description" *ngIf="table.moreDescription && !moreDescriptionVisible" (click)="toggleDescription()" style="padding-top: 8px;">more...</a>
</div>
<p *ngIf="moreDescriptionVisible" [innerHTML]="table.moreDescription" style="flex: 0 0 100%;"></p>

<div *ngIf="visibleRowsCount >= 25" id="div_search">
    <p style="margin-bottom: 0;">
        <a id="tb_search" (click)="toggleSearch()"><span id="text_search">{{this.showSearch ? "Hide Search" :
                "Search"}}</span></a>
        <span id="text_search_span" style="display:none">Search</span>
    </p>
</div>

<table *ngIf="this.showSearch" class="tbSeachField" style="margin-bottom: 10px;" cellspacing="1">
    <p class="tbSeachField">Enter the term(s) you would like to search for.
        <tbody>
            <tr *ngFor="let column of table.columns; let i=index">
                <ng-container *ngIf="column.searchable">
                    <td>{{column.header}}</td>
                    <td><input type="text" class="search_field" (keyup)="filter($event, i)"></td>
                </ng-container>
            </tr>
            <tr>
            <td valign="bottom" height="40px" style="padding-bottom:0">
                <input type="button" id="SeachTB" (click)="toggleSearch()" value="Submit" class="btn btn-success">
            </td>
            </tr>
        </tbody>
</table>

<div class="table-controls">
    <div>
        <div class="buttons-container" *ngIf="objectKeys(table.buttons).length > 0 && table.buttons['']?.Label !== ''">
            <ng-container *ngFor="let buttonKey of objectKeys(table.buttons)">
                <button class="btn btn-success responsive-btn"
                        (click)="handleButtonClick(table.buttons[buttonKey])">
                {{ table.buttons[buttonKey].Label }}
                </button>
            </ng-container>
        </div>

        <div class="paginator-container" *ngIf="visibleRowsCount >= 25 || paginatorInfo?.totalPages > 1">
            <ul class="pagination">
                <li class="paginator-btn" [class.disabled]="!paginatorInfo.canGoBack()"><a (click)="paginatorInfo.goBackOnePage()">
                    <mat-icon>keyboard_double_arrow_left</mat-icon>
                </a></li>
                <li class="paginator-btn" [class.disabled]="!paginatorInfo.canGoBack()"><a (click)="paginatorInfo.goBackAllPages()">
                    <mat-icon>chevron_left</mat-icon>
                </a>
                </li>
                <li>
                    <select #paginatorPageSize name="lstItemView" id="item_view" (change)="paginatorInfo.setCount(paginatorPageSize.value)">
                        <option value="25" [selected]="paginatorInfo.pageSize == 25">25</option>
                        <option value="50" [selected]="paginatorInfo.pageSize == 50">50</option>
                        <option value="100" [selected]="paginatorInfo.pageSize == 100">100</option>
                        <option value="500" [selected]="paginatorInfo.pageSize == 500">500</option>
                        <option value="1000" [selected]="paginatorInfo.pageSize == 1000">1000</option>
                    </select>
                </li>
                <li class="paginator-btn" [class.disabled]="!paginatorInfo.canGoForward()"><a (click)="paginatorInfo.goForwardOnePage()">
                    <mat-icon class="material-icons-outlined">chevron_right</mat-icon>
                </a>
                </li>
                <li class="paginator-btn" [class.disabled]="!paginatorInfo.canGoForward()"><a (click)="paginatorInfo.goForwardAllPages()">
                    <mat-icon>keyboard_double_arrow_right</mat-icon>
                </a>
                </li>
            </ul>
        </div>
    </div>

    <div>
        <span *ngIf="tableSortOrderText && visibleRowsCount >= 25" class="table-sort-order-text">
            Sorted By: {{ tableOrder.columnName }}.
        </span>
    </div>

    <div class="export_button" *ngIf="table.DisplayDownloadIcons == 1">
        <a href="#"
            class="btn btn-success btn-export-pdf " target="_blank"

            style="padding: 0;box-shadow: 0px 1px 0px 0px #670808;" (click)="exportFile('pdf', 'export.pdf')">
            <img [src]="'../../../assets/easysuite/' + GUIthemeID + '/pdf.png'" style="border-radius: 4px;">            
        </a>
        <span style="margin-right: 5px;"></span>

        <a href="#" 
            class="btn btn-success btn-export-txt " target="_blank" 
            style="padding: 0;box-shadow: 0px 1px 0px 0px #670808;" (click)="exportFile('txt', 'export.txt')">
            <img [src]="'../../../assets/easysuite/'+ GUIthemeID +'/txt.png'" style="border-radius: 4px;">
        </a>
        <span style="margin-right: 5px;"></span>

        <a href="#" 
            class="btn btn-success btn-export-xls " target="_blank" 
            style="padding: 0;box-shadow: 0px 1px 0px 0px #670808;" (click)="exportFile('xls', 'export.xls')">
            <img [src]="'../../../assets/easysuite/'+ GUIthemeID +'/xls.png'" style="border-radius: 4px;">
        </a>
    </div>
</div>

<div id="table_css" class="table1">

    <div id="table-scroll" class="table-scroll">
        <div class="table-wrap">
            <table id="rt1" class="rt cf main-table" matSort [matSortActive]="activeColumnIndex" [matSortDirection]="sortDirection" (matSortChange)="sortData($event)">
                <tbody>

                    <!-- The headers of the tables are rendered in this tr tag -->
                    <tr>
                        <th title="" 
                            [mat-sort-header]="i.toString()"
                            [disabled]="column.sortable == '0'"
                            *ngFor="let column of table.columns; let i=index">
                            <div class="table-header"                            
                            [style.text-align]="table.columns[i].headerHorAlign"
                            [style.vertical-align]="table.columns[i].headerVerAlign">
                                {{column.header}}
                                <span *ngIf="column.sortable === '1'" class="triangle_sort up_sort"></span>
                                <a *ngIf="column.headerTooltip != ''" class="infolink sortlink" 
                                title="{{column.headerTooltip}}">?</a>
                            </div>
                        </th>                    
                    </tr>

                    <!-- The rows of the tables are rendered in this tr tag -->
                    <tr *ngFor="let row of this.dataSource.connect() | async;">
                        <td *ngFor="let col of row; let i=index"
                            [ngStyle]="{
                                'text-align': table.columns[i].cellHorAlign,
                                'vertical-align': table.columns[i].cellVerAlign
                            }">
  
                            <ng-container [ngSwitch]="true">
                                
                                <!-- table.columns[i]... must be converted to string because they come from JSON due to tables dB table using an array for GUI table columns.
									 This method will be changed in the future to use tables sub-tables and booleans will be booleans or numbers for action column values.
								1. BOOLEANS (Yes/No) -->
                                <span *ngSwitchCase="table.columns[i].bool.toString() === '1'" class="ng-binding">
                                    {{ col == '1' ? 'Yes' : 'No' }}
                                </span>

                                <!-- 2. Redirect links -->
                                <span *ngSwitchCase="redirectLink(row[i])">

                                    <a (click)="tableLinkClick(buildLink(row[i]))" 
                                        class="element-with-link">

                                        <!-- Determine how to display the link content -->
                                        <ng-container [ngSwitch]="table.columns[i].action.toString()">
                                            
                                            <!-- Edit action: display edit icon -->
                                            <img *ngSwitchCase="'1'" src="../../../../assets/base/b_edit.png" alt="Edit" class="action-icon">
                                            
                                            <!-- Delete action: display delete icon 
											 NOTE! THIS CASE HAS NOT YET BEEN TESTED -->
                                            <img *ngSwitchCase="'2'" src="../../../../assets/base/b_drop.png" alt="Delete" class="action-icon">

                                            <a *ngSwitchCase="'8'" [href]="getUrlFromLink(row[i])" (click)="$event.stopPropagation()" target="_blank">
                                                {{ buildLink(row[i])?.linkText }}
                                            </a>
                                                                                        
                                            <!-- Default case: display the link text for other actions -->
                                            <span *ngSwitchDefault>{{ buildLink(row[i])?.linkText }}</span>
                                        </ng-container>
                                    </a>
                                </span>

                                <!-- 3. Callback actions -->
                                <span *ngSwitchCase="hasCallbackLink(row[i])">

                                    <a (click)="handleCallbackLink(buildCallbackLink(row[i]))" class="element-with-link">
                                        <ng-container [ngSwitch]="this.table.columns[i].action.toString()">

                                            <!-- Edit action: display edit icon 
                                              NOTE! THIS CASE HAS NOT YET BEEN TESTED -->
                                            <img *ngSwitchCase="'1'" src="../../../../assets/base/b_edit.png" alt="Edit" class="action-icon">

                                            <!-- Delete action: display delete icon -->
                                            <img *ngSwitchCase="'2'" src="../../../../assets/base/b_drop.png" alt="Delete" class="action-icon">

                                            <!-- Default case: display the link text for other actions -->
                                            <span *ngSwitchDefault>{{ buildCallbackLink(row[i]).linkText }}</span>
                                        </ng-container>
                                    </a>
                                </span>

                                <!-- 4. Phone number formatting -->
                                <!-- This is a temporary solution until we have the dB table table_columns instead of the delimited values in the dB table tables. -->
                                <span *ngSwitchCase="table.columns[i].header == 'Phone'">
                                    {{ phoneMask(col) }}
                                </span>

                                <!-- 5. Plain text (default case) -->
                                <ng-container *ngSwitchDefault>
                                    <span class="ng-binding">
                                        {{ col }}
                                    </span>
                                </ng-container>

                            </ng-container>
                        </td>
                    </tr>
                    <!-- If there are no results, then the data is still being retrieved or there is no data to show-->
                    <tr *ngIf="this.dataSource.dataLength == 0">
                        <!-- 
                        Loop through each column and only put that message in the first cell.
                        The reason we loop through each column is to ensure there is an empty <td> for every column
                        to keep the table structure consistent, so that the css can be applied correctly.
                        (NOTE: Without the loop, the header cells (apart from the first one) would not have the bottom border because the CSS would not be applied to them)
                        -->
                        <td *ngFor="let column of table.columns; let isFirst = first">
                            <ng-container *ngIf="isFirst">
                                <ng-container *ngIf="this.initialTableLoad">
                                    <span class="noData"><strong>Loading...</strong></span>
                                </ng-container>
                                <ng-container *ngIf="!this.initialTableLoad">
                                    <span class="noData"><strong>No results found</strong></span>
                                </ng-container>
                            </ng-container>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>